"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrameOrderApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class FrameOrderApi extends runtime.BaseAPI {
    /**
     */
    frameOrderGetBaseInformationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/FrameOrder/GetBaseInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    frameOrderGetBaseInformationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.frameOrderGetBaseInformationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取得單筆訂單（含明細）
     */
    frameOrderGetByIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/FrameOrder/GetById`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * 取得單筆訂單（含明細）
     */
    frameOrderGetByIdGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.frameOrderGetByIdGetRaw(requestParameters, initOverrides);
        });
    }
    /**
     * 取得訂單列表（分頁 + 搜尋）
     */
    frameOrderGetPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/FrameOrder/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.FrameOrderSearchModelToJSON)(requestParameters['frameOrderSearchModel']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * 取得訂單列表（分頁 + 搜尋）
     */
    frameOrderGetPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.frameOrderGetPostRaw(requestParameters, initOverrides);
        });
    }
    /**
     * 更新訂單狀態（取消/退款）
     */
    frameOrderUpdateStatusPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            if (requestParameters['status'] != null) {
                queryParameters['status'] = requestParameters['status'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/FrameOrder/UpdateStatus`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * 更新訂單狀態（取消/退款）
     */
    frameOrderUpdateStatusPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.frameOrderUpdateStatusPatchRaw(requestParameters, initOverrides);
        });
    }
}
exports.FrameOrderApi = FrameOrderApi;
